export const SET_CURRENT_URL = "SET_CURRENT_URL";
export const CLICKED_FOOTER_MERCHANT_FEATURES =
  "CLICKED_FOOTER_MERCHANT_FEATURES";
export const CLICKED_FOOTER_TABS_NOT_ON_HEADER =
  "CLICKED_FOOTER_TABS_NOT_ON_HEADER";
export const CLICKED_FOOTER_SHOPEEPAY_APP = "CLICKED_FOOTER_SHOPEEPAY_APP";
